/**
 * Renders CareStart splash copy, turning the source token "(TM)" into a
 * superscript trademark inside a circle.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

export const CARESTART_TRADEMARK_TOKEN = '(TM)';

function CircledTrademark() {
  return (
    <Box
      component="sup"
      aria-label="trademark"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '1.7em',
        height: '1.7em',
        ml: '0.2em',
        border: '0.12em solid',
        borderColor: 'currentColor',
        borderRadius: '50%',
        fontSize: '0.62em',
        fontWeight: 700,
        lineHeight: 1,
        letterSpacing: 0,
        textTransform: 'none',
        verticalAlign: 'super',
      }}
    >
      TM
    </Box>
  );
}

function CareStartTrademarkText({ text }) {
  if (typeof text !== 'string' || !text.includes(CARESTART_TRADEMARK_TOKEN)) {
    return text;
  }

  const parts = text.split(CARESTART_TRADEMARK_TOKEN);
  return parts.map((part, index) => (
    <React.Fragment key={`${index}-${part}`}>
      {part}
      {index < parts.length - 1 ? <CircledTrademark /> : null}
    </React.Fragment>
  ));
}

CareStartTrademarkText.propTypes = {
  text: PropTypes.string,
};

export default CareStartTrademarkText;
